import { compareWithAppVersion, openExternalBrowser as web2AppOpenExternalBrowser } from '@croquiscom-pvt/web2app';

const CAN_OPEN_EXTERNAL_BROWSER_TEST_APP_VERSION = '7.50.0';
const CAN_OPEN_EXTERNAL_BROWSER_RELEASE_APP_VERSION = '7.52.0';

export function openExternalBrowser(url: string, fallback?: (url: string) => void) {
  if (isSupportedOpenExternalBrowser()) {
    web2AppOpenExternalBrowser(url);
  } else {
    fallback?.(url);
  }
}

export function isSupportedOpenExternalBrowser() {
  const originUrl = window.location.origin;
  const isAlpha = originUrl.includes('alpha');
  const isDev = originUrl.includes('dev');

  const canOpenExternalBrowserAppVersion =
    isDev || isAlpha ? CAN_OPEN_EXTERNAL_BROWSER_TEST_APP_VERSION : CAN_OPEN_EXTERNAL_BROWSER_RELEASE_APP_VERSION;

  const canOpenExternalBrowser = compareWithAppVersion(canOpenExternalBrowserAppVersion);

  return canOpenExternalBrowser;
}
